

export const JobServiceType = [
    "",
    "Headhunt",
    "DVTJCUV",
    "Free Connection",
    "Outplacement",
]

export const JobServiceTypeOptions = JobServiceType.map(item => {
    return {
        value: item,
        label: item
    };
})

export const JobStatus = [
    "",
    "On",
    "Off",
    "Pending"
]

export const JobStatusOptions = JobStatus.map(item => {
    return {
        value: item,
        label: item
    };
})

export const CopyPipelineTypes = {
    COPY_LIST_UV_BOOK: "copy list UV & book",
    COPY_LIST_UV_QUALIFY_BOOK: "copy list UV kèm qualify UV & book",
    COPY_LIST_CTV_HR_RECRUITER: "copy list CTV HR, Recruiter"
}

export const CopyPipelineTypesOptions = Object.values(CopyPipelineTypes).map(val => {
    return {
        value: val,
        label: val
    };
})

